import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-feature-card',
    standalone: true,
    templateUrl: './feature-card.component.html'
})
export class FeatureCardComponent {
  @Input() imgSrc!: string;
  @Input() title!: string;
  @Input() text!: string;
}
